import Request from "../../../@api/request";
import LandService from "../landApi";

// import { request } from "../service"
// const baseURL = "http://localhost:3333/";
// const baseURL = "https://back.transfarmer.kr/";
const baseURL = `${process.env.REACT_APP_HOST}`;
export const request = new Request(baseURL);

export default class WeatherService {
  static weather = async (address: string) => {
    const { coordinate } = await LandService.coordinate(address);
    const { JUSO, xpos, ypos } = coordinate;
    console.log("lon", xpos, "lat", ypos);
    const result = await request.get(
      `land/weather?address=${JUSO}&lat=${ypos}&lon=${xpos}`
    );
    return result.data;
  };

  static weatherPast = async (address: string) => {
    const { coordinate } = await LandService.coordinate(address);
    const { xpos, ypos } = coordinate;
    const result = await request.get(
      `land/weather/past?lat=${ypos}&lon=${xpos}`
    );

    return result.data;
  };

  static weatherPast10 = async (address: string) => {
    const { coordinate } = await LandService.coordinate(address);
    const { xpos, ypos } = coordinate;
    const result = await request.get(
      `land/weather/past10Year?lat=${ypos}&lon=${xpos}`
    );
    return result.data;
  };

  static rainyDays = async (pnu: string) => {
    const res = await request.get(`/weather/rainy-days?pnu=${pnu}`);
    return res.data;
  };
}
